function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b604d933-963c-47a0-8899-51e94ba39cbc",
  x1: 882.01746,
  y1: 830.63698,
  x2: 882.01746,
  y2: 326.59687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Savings");

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 559,
  cy: 734.87374,
  rx: 559,
  ry: 67.94571,
  fill: "#6c63ff",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M997.48613,816.76857s29.1545-37.09867,26.79711-73.90617a71.48961,71.48961,0,0,1,11.25042-43.79869,120.23213,120.23213,0,0,1,13.69883-17.199",
  transform: "translate(-41 -48.59028)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1047.88531,658.66009c-2.05564,5.152,1.31185,23.81438,1.31185,23.81438s15.28968-11.21824,17.34531-16.37028a10.04371,10.04371,0,0,0-18.65716-7.4441Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1021.07889,681.04583c1.07458,5.44191,14.04418,19.27711,14.04418,19.27711s6.73729-17.7266,5.66271-23.16851a10.04371,10.04371,0,1,0-19.70689,3.8914Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.29435,730.08232c3.67474,4.15516,21.85466,9.55092,21.85466,9.55092s-3.13276-18.70319-6.80751-22.85835a10.04371,10.04371,0,1,0-15.04715,13.30743Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M996.43655,770.38483c2.9197,4.7164,19.92629,13.10683,19.92629,13.10683s.073-18.9636-2.8467-23.68a10.04371,10.04371,0,1,0-17.07959,10.57317Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1054.31214,709.13616c-5.12779,2.1154-23.828-1.03487-23.828-1.03487s11.03971-15.41908,16.1675-17.53448a10.04371,10.04371,0,1,1,7.66053,18.56935Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1046.86343,756.18335c-5.52582.48418-22.42673-8.11712-22.42673-8.11712s15.14753-11.40945,20.67335-11.89364a10.04372,10.04372,0,1,1,1.75338,20.01076Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1033.349,800.91729c-5.36452,1.411-23.47591-4.21042-23.47591-4.21042s13.00156-13.80518,18.36608-15.21622a10.04371,10.04371,0,0,1,5.10983,19.42664Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1047.88531,658.66009c-2.05564,5.152,1.31185,23.81438,1.31185,23.81438s15.28968-11.21824,17.34531-16.37028a10.04371,10.04371,0,0,0-18.65716-7.4441Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1021.07889,681.04583c1.07458,5.44191,14.04418,19.27711,14.04418,19.27711s6.73729-17.7266,5.66271-23.16851a10.04371,10.04371,0,1,0-19.70689,3.8914Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.29435,730.08232c3.67474,4.15516,21.85466,9.55092,21.85466,9.55092s-3.13276-18.70319-6.80751-22.85835a10.04371,10.04371,0,1,0-15.04715,13.30743Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M996.43655,770.38483c2.9197,4.7164,19.92629,13.10683,19.92629,13.10683s.073-18.9636-2.8467-23.68a10.04371,10.04371,0,1,0-17.07959,10.57317Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1054.31214,709.13616c-5.12779,2.1154-23.828-1.03487-23.828-1.03487s11.03971-15.41908,16.1675-17.53448a10.04371,10.04371,0,1,1,7.66053,18.56935Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1046.86343,756.18335c-5.52582.48418-22.42673-8.11712-22.42673-8.11712s15.14753-11.40945,20.67335-11.89364a10.04372,10.04372,0,1,1,1.75338,20.01076Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1033.349,800.91729c-5.36452,1.411-23.47591-4.21042-23.47591-4.21042s13.00156-13.80518,18.36608-15.21622a10.04371,10.04371,0,0,1,5.10983,19.42664Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.25
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M997.73313,815.224s41.6868-22.10219,54.44688-56.70754a71.48967,71.48967,0,0,1,28.03357-35.48261,120.23268,120.23268,0,0,1,19.49315-10.17255",
  transform: "translate(-41 -48.59028)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1107.87816,691.10132c-3.967,3.87709-8.45082,22.30313-8.45082,22.30313s18.524-4.06019,22.491-7.93728a10.04371,10.04371,0,0,0-14.04019-14.36585Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M1074.3,700.70418c-1.22278,5.41054,5.02792,23.31451,5.02792,23.31451s13.34257-13.47587,14.56536-18.8864A10.04371,10.04371,0,0,0,1074.3,700.70418Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M1037.25615,737.9223c1.67576,5.28781,16.10967,17.58762,16.10967,17.58762s4.71494-18.36825,3.03919-23.65606a10.04371,10.04371,0,1,0-19.14886,6.06844Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1015.56934,772.39385c.75805,5.49495,12.90579,20.05709,12.90579,20.05709s7.75122-17.30728,6.99318-22.80222a10.04371,10.04371,0,1,0-19.899,2.74513Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M1093.29962,739.85175c-5.54513-.144-21.36466-10.60177-21.36466-10.60177s16.34087-9.62285,21.886-9.47889a10.04371,10.04371,0,0,1-.52133,20.08066Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1067.42527,779.84474c-5.248-1.79654-17.21368-16.50865-17.21368-16.50865s18.47152-4.29259,23.71952-2.496a10.04371,10.04371,0,0,1-6.50584,19.0047Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1036.94291,815.265c-5.47612-.88383-19.75594-13.36222-19.75594-13.36222s17.48044-7.35241,22.95656-6.46858a10.04371,10.04371,0,0,1-3.20062,19.8308Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M678.139,143.66786c-55.23694-1.91782-107.84673-19.75-158.08325-39.25967S420.05863,63.28342,366.14447,52.94556c-34.67659-6.64912-74.3324-7.58988-102.27311,11.0022-26.88732,17.89113-35.5752,48.775-40.24617,77.43129-3.51427,21.56-5.58038,44.25117,4.04873,64.43513,6.68515,14.013,18.55538,25.7921,26.76376,39.21411,28.56248,46.70419,8.37426,104.29565-22.57894,149.89816-14.51955,21.39126-31.3609,41.79852-42.56505,64.57s-16.38724,48.86421-6.58463,72.09313c9.71618,23.0241,32.87083,40.31823,57.95274,52.48183,50.94227,24.70472,110.9724,31.77548,169.50971,35.78007,129.57911,8.86461,259.85027,5.02668,389.77341,1.18282,48.08151-1.42252,96.3749-2.86408,143.67524-10.29895,26.26671-4.12871,53.38535-10.68184,72.45464-26.50142,24.20831-20.08285,30.20875-54.08912,13.98737-79.27063-27.20955-42.23918-102.44087-52.7307-121.45881-98.06054-10.46833-24.9516.28208-52.74482,15.49507-75.88559,32.63531-49.64219,87.33654-93.19327,90.21783-149.93506,1.97891-38.97118-24.317-77.9997-64.9765-96.4385C906.7205,65.31607,847.62237,67.74728,816.1811,99.74087,783.80547,132.68522,726.90975,145.36117,678.139,143.66786Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff",
  opacity: 0.1
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 542.56303,
  cy: 664.53343,
  rx: 37.55691,
  ry: 39.86537,
  fill: "#fbd56f"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 542.56303,
  cy: 664.53343,
  rx: 37.55691,
  ry: 39.86537,
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 549.04466,
  cy: 665.4213,
  rx: 37.55691,
  ry: 38.9775,
  fill: "#fbd56f"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M605.25656,749.33407l-3.90663-2.17528s-1.82727,7.62536-1.22995,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33959-.91772-10.23078-1.42825-11.57336C682.468,744.26931,605.25656,749.33407,605.25656,749.33407Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M605.25656,749.33407l-3.90663-2.17528s-1.82727,7.62536-1.22995,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33959-.91772-10.23078-1.42825-11.57336C682.468,744.26931,605.25656,749.33407,605.25656,749.33407Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 601.45832,
  cy: 698.56851,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M620.96224,735.66238l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.2318,51.82048,11.74045,81.27523-1.65235a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33959-.91772-10.23078-1.42825-11.57336C698.17365,730.59762,620.96224,735.66238,620.96224,735.66238Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M620.96224,735.66238l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.2318,51.82048,11.74045,81.27523-1.65235a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33959-.91772-10.23078-1.42825-11.57336C698.17365,730.59762,620.96224,735.66238,620.96224,735.66238Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 617.164,
  cy: 684.89682,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M634.84687,717.69359l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57335C712.05828,712.62883,634.84687,717.69359,634.84687,717.69359Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M634.84687,717.69359l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57335C712.05828,712.62883,634.84687,717.69359,634.84687,717.69359Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 631.04863,
  cy: 666.92803,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M619.47062,698.98824,615.564,696.813s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33959-.91773-10.23077-1.42825-11.57336C696.682,693.92348,619.47062,698.98824,619.47062,698.98824Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M619.47062,698.98824,615.564,696.813s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33959-.91773-10.23077-1.42825-11.57336C696.682,693.92348,619.47062,698.98824,619.47062,698.98824Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref43 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 615.67239,
  cy: 648.22268,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M654.06171,683.977l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70276,2.70276,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C731.27312,678.91221,654.06171,683.977,654.06171,683.977Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M654.06171,683.977l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70276,2.70276,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C731.27312,678.91221,654.06171,683.977,654.06171,683.977Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 650.26347,
  cy: 633.21142,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M630.69041,673.88744l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57335C707.90182,668.82268,630.69041,673.88744,630.69041,673.88744Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M630.69041,673.88744l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57335C707.90182,668.82268,630.69041,673.88744,630.69041,673.88744Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref49 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 626.89217,
  cy: 623.12188,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M646.29411,654.40937l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C723.50552,649.34461,646.29411,654.40937,646.29411,654.40937Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M646.29411,654.40937l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C723.50552,649.34461,646.29411,654.40937,646.29411,654.40937Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 642.49587,
  cy: 603.64381,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M653.99087,631.28938l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C731.20228,626.22462,653.99087,631.28938,653.99087,631.28938Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M653.99087,631.28938l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C731.20228,626.22462,653.99087,631.28938,653.99087,631.28938Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 650.19263,
  cy: 580.52382,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M723.38554,754.69624l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57335C800.597,749.63148,723.38554,754.69624,723.38554,754.69624Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M723.38554,754.69624l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57335C800.597,749.63148,723.38554,754.69624,723.38554,754.69624Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 719.58731,
  cy: 703.93068,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M737.27017,736.72745l-3.90663-2.17529s-1.82727,7.62536-1.22995,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33959-.91772-10.23077-1.42825-11.57336C814.48158,731.66268,737.27017,736.72745,737.27017,736.72745Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M737.27017,736.72745l-3.90663-2.17529s-1.82727,7.62536-1.22995,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33959-.91772-10.23077-1.42825-11.57336C814.48158,731.66268,737.27017,736.72745,737.27017,736.72745Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref61 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 733.47193,
  cy: 685.96189,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M721.89393,718.0221l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C799.10534,712.95734,721.89393,718.0221,721.89393,718.0221Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M721.89393,718.0221l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03428,2.33847c8.987,2.23181,51.82048,11.74046,81.27524-1.65234a2.70278,2.70278,0,0,0,1.56546-2.172c.36128-3.33958-.91772-10.23077-1.42825-11.57335C799.10534,712.95734,721.89393,718.0221,721.89393,718.0221Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref64 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 718.09569,
  cy: 667.25654,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M756.485,703.01083l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82048,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33959-.91772-10.23077-1.42825-11.57336C833.69643,697.94607,756.485,703.01083,756.485,703.01083Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M756.485,703.01083l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82048,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33959-.91772-10.23077-1.42825-11.57336C833.69643,697.94607,756.485,703.01083,756.485,703.01083Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref67 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 752.68678,
  cy: 652.24527,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M733.11371,692.92129l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33959-.91773-10.23077-1.42825-11.57336C810.32512,687.85653,733.11371,692.92129,733.11371,692.92129Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M733.11371,692.92129l-3.90663-2.17528s-1.82727,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33848c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33959-.91773-10.23077-1.42825-11.57336C810.32512,687.85653,733.11371,692.92129,733.11371,692.92129Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref70 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 729.31548,
  cy: 642.15573,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M748.71742,673.44323l-3.90663-2.17529s-1.82728,7.62537-1.23,13.05927a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57336C825.92883,668.37846,748.71742,673.44323,748.71742,673.44323Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M748.71742,673.44323l-3.90663-2.17529s-1.82728,7.62537-1.23,13.05927a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82047,11.74045,81.27523-1.65234a2.70281,2.70281,0,0,0,1.56547-2.172c.36127-3.33958-.91773-10.23077-1.42825-11.57336C825.92883,668.37846,748.71742,673.44323,748.71742,673.44323Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref73 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 744.91918,
  cy: 622.67767,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M756.41418,650.32324l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82048,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91772-10.23077-1.42825-11.57335C833.62559,645.25848,756.41418,650.32324,756.41418,650.32324Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fbd56f"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M756.41418,650.32324l-3.90663-2.17528s-1.82728,7.62536-1.23,13.05926a2.707,2.707,0,0,0,2.03429,2.33847c8.987,2.23181,51.82048,11.74046,81.27523-1.65234a2.70279,2.70279,0,0,0,1.56547-2.172c.36127-3.33958-.91772-10.23077-1.42825-11.57335C833.62559,645.25848,756.41418,650.32324,756.41418,650.32324Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref76 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 752.61594,
  cy: 599.55768,
  rx: 41.10839,
  ry: 9.26638,
  fill: "#fbd56f"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M1004.19119,809.234c-5.7223-.2017-5.92664-2.42-13.28367-6.25148-4.15269-2.16183-10.45932-8.44156-15.15979-13.49521q-.56457-.60741-1.09357-1.186c1.24289-.02721,1.94786-.04007,1.94786-.04007s-1.8392-16.13283-.20434-19.9644.4088-26.61921.4088-26.61921,1.02171-17.34285-.81761-21.37606.61315-29.84586.61315-29.84586,1.63485-15.32622,2.04366-46.58362-17.984-32.26578-17.984-32.26578-2.45234-.18957-6.17576-.54447c-.35754-.03385-.73578-.07048-1.11577-.10734,2.41142-5.048,3.81736-8.82626,3.81736-8.82626s-3.06537-29.24082-3.883-34.28235c-.81736-5.04146-5.72205-25.81254-5.72205-25.81254s-3.4743-8.87309-5.51783-15.12457-8.17452-13.51128-8.17452-13.51128-11.03567-21.77939-14.10116-25.006c-1.42228-1.49635-3.41691-3.38385-5.14583-4.977-.31175-.28744-.60965-.56017-.8992-.82434a36.518,36.518,0,0,0,.73154-6.9033s-11.44435-11.293-12.26172-14.11625S890.56505,448.261,890.56505,448.261s-6.131-11.293-13.07933-11.49471a56.68235,56.68235,0,0,0-9.84156.29834c1.42665-5.28206,3.11452-10.81544,4.63024-15.564.16879-.52921.33446-1.04507.49838-1.55335A34.99737,34.99737,0,0,0,885.327,404.76247c.145-.32757.27595-.65846.40731-.98942.0736.00185.14658.01385.22019.01287a5.48659,5.48659,0,0,0,.85978-.07793c2.28742-.39287,4.22354-2.976,3.1689-5.01456a.74746.74746,0,0,0,.66642.36622c.76235-.02536,1.69261-1.12828,1.87126-2.09862.03093-.16828.04778-.33859.07385-.5076.03243-.21057.06711-.4207.09206-.63225.02346-.19881.03843-.39811.05514-.59759.01747-.20576.03356-.41134.04392-.6176.00973-.193.01572-.38573.01908-.579.00412-.2222.00287-.44415-.00112-.66634-.00337-.17788-.00549-.35546-.014-.53315-.01273-.27033-.03518-.53986-.06-.80939-.0101-.1106-.01235-.22189-.02457-.33231l-.00225.01594a18.109,18.109,0,0,0-.65843-3.25213c-1.12937-3.74841-3.4985-7.46575-2.58558-11.27115.01-.041.02807-.07836.03868-.119l.00124.00738c.76073-2.95312,3.31612-5.09864,4.87974-7.73712.14908-.25168.28006-.51136.40918-.77171.02358-.04764.0519-.09331.07485-.14126.09406-.19616.17365-.39768.25649-.59809.05339-.12882.1119-.25568.16068-.3861.06574-.17579.12026-.3549.17777-.53334.05252-.16243.10765-.324.15356-.4884.04392-.15812.07947-.31809.11727-.47781.04578-.19241.09107-.38457.128-.57894.02645-.13935.047-.2795.06886-.41972.03444-.22035.06587-.44082.08933-.66283.01272-.12021.022-.24048.03131-.36112.01958-.24761.03343-.49523.03954-.744.0025-.09958.0035-.199.00375-.2987q.00149-.40772-.02071-.81529c-.00449-.08168-.00873-.163-.01472-.24467-.02046-.28965-.05065-.57826-.08858-.86663-.00548-.04166-.007-.08364-.013-.12531l-.00212.01145a14.53163,14.53163,0,0,0-2.927-6.95063,17.91132,17.91132,0,0,0-14.71006-6.36234,24.64481,24.64481,0,0,1-4.62512.08507c-2.56575-.376-4.73553-2.00574-6.78031-3.58069q-8.55874-6.59278-17.11775-13.18556a21.123,21.123,0,0,0-6.47043-3.84671c-2.419-.74032-5.319-.48489-7.10965,1.28241-3.20483,3.16288-1.16766,8.60584-2.45434,12.89448-1.11452,3.71456-4.70209,6.23184-8.41628,7.48655s-7.68837,1.53008-11.50485,2.43837a6.34988,6.34988,0,0,0-3.07859,1.41461,5.95545,5.95545,0,0,0-1.3377,4.28741,23.1183,23.1183,0,0,0,2.65731,10.90512c.72168,1.36955,1.5958,2.7532,2.36352,4.15649.06337.1159.125.23211.18662.34825.08583.161.17191.322.25387.48366q.19929.39323.37974.78871c.0519.11387.09843.22829.14758.3424q.12051.28012.22879.56128c.04579.11941.09032.23888.13224.35859.07734.22066.146.442.20883.66376a7.38075,7.38075,0,0,1,.111,4.02108c-.58857,2.16762-2.28094,3.8376-3.7732,5.5311a10.759,10.759,0,0,0-2.52158,4.6745l-.00711.03871a3.75722,3.75722,0,0,0-.04641,1.2328c.00736.05114.01347.10278.0237.152a2.15891,2.15891,0,0,0,.07548.27,1.87035,1.87035,0,0,0,.08.18779,1.7407,1.7407,0,0,0,.10629.20878,1.60072,1.60072,0,0,0,.25973.30652,1.68959,1.68959,0,0,0,.14334.10655,1.73817,1.73817,0,0,0,.26235.161c.05614.02764.11327.05392.17465.07712a2.42158,2.42158,0,0,0,.41866.11424c.04017.00739.07423.02007.116.026a3.83834,3.83834,0,0,0,.65768.02789c.06338-.0021.13236-.00991.19861-.01471a6.24239,6.24239,0,0,0,.62774-.0794c.07635-.01336.15095-.02542.23041-.04186.30128-.0621.61714-.13861.96445-.24669a21.62464,21.62464,0,0,0,3.33882-1.32c-.00125.12286-.00936.24405-.00936.36715,0,.21179,0,.43362.02046.64542a33.98647,33.98647,0,0,0,2.20746,11.56684,34.93447,34.93447,0,0,0,10.65717,14.72511q-.0887.52256-.19486,1.04918c-.98515,4.83589-3.04515,9.68784-4.31624,9.31275a17.33266,17.33266,0,0,0-3.78891-.41546c-.38586-.01145-.75973-.01662-1.11465-.01878l-.00125-.00135a15.11015,15.11015,0,0,0-3.474,0,3.76531,3.76531,0,0,1-1.52046-.2097,20.72951,20.72951,0,0,0-10.21007-.57279c-7.06686,1.448-17.81635,4.09777-20.76333,7.26786-4.496,4.83989-11.03554,9.47807-18.3927,29.64417,0,0-3.67851,12.30132-6.53966,13.91461a19.09761,19.09761,0,0,1,1.94149-.87266,5.178,5.178,0,0,1-1.53268,1.67928,22.55366,22.55366,0,0,1,3.21856-1.34216c-2.23329,13.13871,1.073,50.72157,1.073,50.72157s-2.65668,6.4807.81749,10.3122c2.06475,2.27718,3.1865,5.82783,3.7606,8.34093q-.24213.37761-.50311.78224v.00407c-1.8392,2.85144-4.29978,6.57006-5.91417,8.619-2.86115,3.62987-2.04366,15.12457-2.04366,15.12457s-.61315,5.44486-2.65669,7.46144-1.635,9.47807-1.635,9.47807l-5.31337,19.56112s-4.90481,4.43654-4.90481,6.45311-3.88286,7.66314-3.88286,7.66314-5.92664,9.67971,0,8.26812a18.59535,18.59535,0,0,0,5.98365-3.00877l-.00287.14489q-.0131.53208-.02158,1.08113c-.16754,10.54283.98091,25.37707,8.75486,25.37707,12.0575,0,43.12072,14.3179,43.12072,14.3179,6.33532,4.83988,14.91864,3.22659,14.91864,3.22659s-15.123,15.12457-14.7143,21.376-8.5832,16.53617-8.5832,16.53617l-27.79351,54.24681a41.60631,41.60631,0,0,0,1.99226,11.11881c-.132.11529-.269.2254-.3982.34358-10.67988,9.75634-11.60778,29.07144-11.60778,29.07144l-2.45234,9.88135L788.792,830.40834s48.22974,1.00831,56.60872-1.21,6.53967-11.49464-4.496-13.30964-13.69235-6.65476-17.37087-8.873c-2.481-1.49635-11.29315-11.168-16.76183-17.29847-.08371-.0938-.15918-.17892-.24127-.27107l1.26709-7.0331c2.45234-1.21,6.13086-13.30964,6.13086-13.30964s0-4.83983,2.45234-6.25148,7.5615-15.93119,7.5615-15.93119,11.03566-18.35116,10.42252-20.77108,7.9703-14.72123,7.9703-14.72123S856.845,697.3122,856.232,694.7914s11.64869-15.427,11.64869-15.427a40.92327,40.92327,0,0,0,10.85166-12.495c1.10354-.17745,2.2888-.367,3.53954-.57672,16.04665-2.62962,42.712-7.38481,45.69158-8.70771,4.08732-1.81493,3.26995,6.25148,1.635,13.10794s-2.861,39.72721-1.02183,43.96206,1.02183,11.09136,1.02183,11.09136l-2.45235,36.904,1.63486,7.86477s-5.51784,4.43655-3.26984,7.0581.20435,13.91462.20435,13.91462c.19311-.07146.4219-.14132.67876-.21-.19685.44273-.3841.89759-.552,1.37565-3.16766,9.03035-1.35279,23.84034-1.35279,23.84034v11.69628s56.6086,1.00832,69.07478,1.00832,29.63271-6.04984,30.65454-10.88967S1009.91324,809.43562,1004.19119,809.234ZM843.18461,599.29579l-3.70858.31194A30.78883,30.78883,0,0,1,843.18461,599.29579Zm22.608-154.78831c.51921-2.33282,1.14945-4.842,1.84418-7.41565Zm6.99276,160.444a15.00237,15.00237,0,0,1-11.0111.01213l-.02457-.01213s.20434-14.11625,1.83932-19.96439,3.883-16.53617,3.883-16.53617,1.83919-14.72129,3.67839-21.37605,8.992-43.76042,12.67064-46.1804,5.72206,1.815,5.72206,1.815.54965-.0112,1.47055-.11326q.25917.58028.58546,1.23446c4.36114,8.81259,17.1543,26.90967,17.1543,26.90967a29.46706,29.46706,0,0,1,9.40069,9.27637c3.47417,5.84814,4.496,19.56112,4.496,19.56112s7.76571,30.45078,11.44435,34.68563c1.83932,2.11745,1.0217,3.37985-.25349,4.1099a18.10626,18.10626,0,0,0-6.4496,5.957c-.52358.83062-1.07784,1.7431-1.64022,2.71523-1.40618-.32572-2.66529-.66382-3.71419-1.01724C912.02311,602.66462,878.30321,602.53155,872.78538,604.95146Z",
  transform: "translate(-41 -48.59028)",
  fill: "url(#b604d933-963c-47a0-8899-51e94ba39cbc)"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M923.14849,816.61211v11.59844s55.39253.99987,67.59089.99987,28.99609-5.9992,29.996-10.79855-13.99812-8.79881-19.59736-8.99879-5.79922-2.39967-12.99825-6.19916c-4.06342-2.14371-10.23466-8.37087-14.834-13.38221-3.54747-3.86747-6.16313-7.015-6.16313-7.015s-29.796-.59992-38.39483,4.19943c-1.97971,1.10784-3.34755,3.27556-4.2754,5.95521C921.37275,801.92608,923.14849,816.61211,923.14849,816.61211Z",
  transform: "translate(-41 -48.59028)",
  fill: "#434175"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M924.47233,792.97131c6.24711-2.17173,42.82221-3.01561,48.83336-3.1396-3.54747-3.86747-6.16313-7.015-6.16313-7.015s-29.796-.59992-38.39483,4.19943C926.768,788.12394,925.40018,790.29166,924.47233,792.97131Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M763.77,608.04022s1.15585.6999,3.2316,1.95174c.37592.224.77987.47193,1.2118.73188,1.31583.79591,2.8956,1.74378,4.69936,2.83163,25.1326,15.14595,93.69138,56.20443,97.44288,55.87648.98385-.084,3.93946-.52794,8.01894-1.19186,1.07983-.176,2.23969-.36394,3.4635-.57192,15.70188-2.60763,41.79436-7.323,44.71-8.63482,3.99946-1.79976,3.19957,6.19916,1.59978,12.99825s-2.79962,39.39469-.99986,43.59412.99986,10.99852.99986,10.99852l-2.39967,36.59507,1.59978,7.799s-5.39927,4.3994-3.19957,6.999.2,13.79814.2,13.79814c6.39914-2.39967,49.79329-3.19956,49.79329-3.19956s-1.79975-15.99785-.2-19.79734.39995-26.39644.39995-26.39644.99986-17.19768-.79989-21.19714.59991-29.596.59991-29.596,1.59979-15.19795,1.99974-46.19377-17.59763-31.99569-17.59763-31.99569-2.39968-.188-6.04318-.53994c-7.127-.68389-19.00545-1.99173-26.94037-3.71549a44.89987,44.89987,0,0,1-4.81136-1.27583c-9.79868-3.33556-42.79423-3.46753-48.19351-1.06785a14.50073,14.50073,0,0,1-10.77452.012l-.024-.012-4.19944-6.79908-40.11061,3.41953-4.25138.36394-39.48672,3.36756-2.7156.23195Z",
  transform: "translate(-41 -48.59028)",
  fill: "#565387"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M924.5483,638.71609c11.65043,5.67921,22.7689-14.45406,27.95224-25.81654-7.127-.68389-19.00545-1.99173-26.94037-3.71549C920.34086,617.94289,913.37783,633.2728,924.5483,638.71609Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M889.553,502.65442a12.214,12.214,0,0,0,1.41182,3.91146c4.2674,8.73884,16.78573,26.68442,16.78573,26.68442a28.991,28.991,0,0,1,9.19876,9.19876c3.39954,5.79921,4.39941,19.39738,4.39941,19.39738s7.599,30.19593,11.19849,34.39537c1.79976,2.09971.99986,3.35155-.248,4.07545a17.81172,17.81172,0,0,0-6.31116,5.90719c-5.24328,8.43087-13.61413,25.15261-1.83974,30.89185,15.99785,7.79895,30.99582-33.07554,30.99582-33.07554s-2.99959-28.9961-3.79948-33.99542-5.59925-25.59655-5.59925-25.59655-3.39954-8.79882-5.39927-14.998-7.99892-13.3982-7.99892-13.3982S921.5487,494.45552,918.54911,491.256c-1.39181-1.48381-3.34355-3.35555-5.03536-4.93534-1.95569-1.82776-3.56349-3.26355-3.56349-3.26355S889.353,497.85506,889.553,502.65442Z",
  transform: "translate(-41 -48.59028)",
  fill: "#ee8e9e"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M753.97128,814.21244l36.3951,16.19781s47.19364.99987,55.39253-1.19983,6.39914-11.39847-4.3994-13.19823-13.3982-6.59911-16.99771-8.79881c-2.4277-1.48381-11.05052-11.07451-16.4018-17.15369-2.57563-2.92761-4.3954-5.04332-4.3954-5.04332s-6.99906-18.59749-26.39644-14.39806a19.876,19.876,0,0,0-9.43872,4.96732c-10.4506,9.6747-11.35848,28.82813-11.35848,28.82813Z",
  transform: "translate(-41 -48.59028)",
  fill: "#434175"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M768.21336,610.72384c1.31583.79591,2.8956,1.74378,4.69936,2.83163,25.1326,15.14595,93.69138,56.20443,97.44288,55.87648.98385-.084,3.93946-.52794,8.01894-1.19186,1.07983-.176,2.23969-.36394,3.4635-.57192.048-.076.092-.152.136-.228a45.96453,45.96453,0,0,0,4.57937-11.20648c4.19943-15.99784-16.59777-28.1962-16.59777-28.1962l-4.3994-3.41953c-4.99933-8.41889-40.99448-16.3778-40.99448-16.3778l-4.63937-3.1156-2.47569-1.66376-.65186-.43595-5.63127-3.78348-28.19621,1.99973-8.37484,5.38326-.88392.56794-3.10754,1.99973Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M767.72944,775.58563c7.655,26.47644,39.63465,17.82961,39.63465,17.82961l.59591-3.35555c-2.57563-2.92761-4.3954-5.04332-4.3954-5.04332s-6.99906-18.59749-26.39644-14.39806A19.876,19.876,0,0,0,767.72944,775.58563Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M759.37055,655.43383c11.79841,0,42.19432,14.19809,42.19432,14.19809,6.19916,4.79935,14.598,3.19957,14.598,3.19957s-14.798,14.998-14.39806,21.19714-8.39887,16.39779-8.39887,16.39779l-27.19633,53.79275c1.99973,38.19486,41.19445,27.59628,41.19445,27.59628l1.59978-8.99878c2.39968-1.19984,5.99919-13.19822,5.99919-13.19822s0-4.79936,2.39968-6.19917,7.399-15.79787,7.399-15.79787,10.79855-18.19755,10.19863-20.59722,7.79895-14.598,7.79895-14.598,14.19808-13.99811,13.59817-16.49777S867.756,680.63044,867.756,680.63044a40.38128,40.38128,0,0,0,10.61859-12.39035,45.96461,45.96461,0,0,0,4.57936-11.20647c3.38353-12.88228-9.44672-23.30487-14.57-26.86838-1.23987-.8639-2.02775-1.32782-2.02775-1.32782l-4.39941-3.41954c-2.27167-3.83149-10.95853-7.563-19.75334-10.49461-6.34314-2.1157-12.74628-3.81547-16.83772-4.83533-2.70765-.67191-4.40342-1.04786-4.40342-1.04786l-4.63936-3.11559-1.63176-1.09585-1.4958-1.00387-5.63127-3.78347-12.54631.88786L779.36786,602.041l-8.37485,5.38325-3.99145,2.56768L751.37163,620.0386s-.41195,3.84748-.54392,9.01077c-.008.39995-.016.8039-.024,1.21983C750.6397,640.7238,751.76357,655.43383,759.37055,655.43383Z",
  transform: "translate(-41 -48.59028)",
  fill: "#565387"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M819.56244,431.464l4.19944,14.998s7.399,25.79652,8.19889,27.59628,20.19728,19.99731,20.99717,20.39725,11.36244,6.39914,11.36244,6.39914.83592-32.99555.036-42.59426a27.40535,27.40535,0,0,1,.51995-6.28714c1.2758-7.523,4.50339-18.55351,7.179-27.04836,2.23969-7.11906,4.09945-12.45833,4.09945-12.45833s-46.7937-1.99973-45.19391,2.59965c.60392,1.73976.408,4.64737-.176,7.563-.96388,4.79537-2.97962,9.60671-4.22345,9.23477a16.74457,16.74457,0,0,0-3.70751-.412C821.1262,431.4,819.56244,431.464,819.56244,431.464Z",
  transform: "translate(-41 -48.59028)",
  fill: "#ee8e9e"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M830.785,422.62919a34.60953,34.60953,0,0,0,41.27042,2.29571c2.23969-7.11906,4.09945-12.45833,4.09945-12.45833s-46.7937-1.99973-45.19391,2.59965C831.56483,416.806,831.36886,419.71359,830.785,422.62919Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M887.5575,394.87684a34.46269,34.46269,0,0,1-1.73,10.8,28.26947,28.26947,0,0,1-1,2.65,34.59827,34.59827,0,0,1-64.28-1.34,34.09973,34.09973,0,0,1-2.16-11.47c-.02-.21-.02-.43-.02-.64a34.595,34.595,0,1,1,69.19007,0Z",
  transform: "translate(-41 -48.59028)",
  fill: "#ee8e9e"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M819.56244,431.464l4.19944,14.998s7.399,25.79652,8.19889,27.59628,20.19728,19.99731,20.99717,20.39725,11.36244,6.39914,11.36244,6.39914.83592-32.99555.036-42.59426a27.40535,27.40535,0,0,1,.51995-6.28714l-2.71966,11.08649.2,22.197,1.59978,1.19984-3.59951,5.39927v-3.99946s-12.79828-12.39833-14.798-17.59763-9.19876-14.614-9.19876-14.614-8.1989-13.78215-8.39887-16.18183c-.156-1.87174-3.59951-6.19916-5.10732-8.01093C821.1262,431.4,819.56244,431.464,819.56244,431.464Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M889.553,502.65442a12.214,12.214,0,0,0,1.41182,3.91146c4.37139-.44794,19.26938-3.22757,22.54892-20.24527-1.95569-1.82776-3.56349-3.26355-3.56349-3.26355S889.353,497.85506,889.553,502.65442Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M750.80374,630.2692c4.03539-2.85559,7.87491-6.75106,10.1666-7.83092,3.39954-1.59979,8.59884-6.79909,8.59884-6.79909s1.31984-.89587,3.34354-2.08372c3.71151-2.17571,9.79468-5.32729,14.45406-5.71523,4.17542-.34795,18.04557-1.23584,28.95611-1.91575,7.89493-.49593,14.23807-.88387,14.23807-.88387s12.99825-4.59938,18.5975-1.59978a58.76014,58.76014,0,0,0,12.5983,4.59938s.004-.43595.024-1.18786l-.024-.012-4.19944-6.79908-44.362,3.78347-5.63127-3.78347-28.1962,1.99973-8.37485,5.38325-7.22305.61594s1.15585.6999,3.2316,1.95174L751.37163,620.0386S750.89172,624.506,750.80374,630.2692Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M744.97249,632.037a18.10327,18.10327,0,0,0,5.85522-2.9836v-.004c4.02744-2.85161,7.855-6.73507,10.14263-7.81093,3.39954-1.59979,8.59884-6.79908,8.59884-6.79908s10.59857-7.199,17.7976-7.79895c1.9637-.164,6.06715-.44794,10.99852-.76792,5.04732-.33594,10.95453-.71189,16.32583-1.04385,3.09558-.196,6.01115-.38,8.47483-.53191,4.41542-.272,7.395-.456,7.395-.456s12.99825-4.59938,18.5975-1.59978a58.76014,58.76014,0,0,0,12.5983,4.59938s.2-13.99811,1.79976-19.79733,3.79948-16.39779,3.79948-16.39779,1.79976-14.598,3.59952-21.19715,8.79881-43.39415,12.39833-45.79383,5.59924,1.79976,5.59924,1.79976,23.99677-.4,24.39672-26.79639c0,0-11.19849-11.19849-11.99839-13.99811S889.953,451.46132,889.953,451.46132s-5.99919-11.1985-12.79828-11.39847a54.7025,54.7025,0,0,0-9.63073.296l-5.76719,23.50084.2,22.197,1.59979,1.19984-3.59952,5.39927V488.6563s-12.79828-12.39833-14.798-17.59762-9.19876-14.614-9.19876-14.614-8.19889-13.78215-8.39886-16.18183-5.79922-8.83081-5.79922-8.83081a14.59526,14.59526,0,0,0-3.39954,0,3.63848,3.63848,0,0,1-1.48779-.208,20.02651,20.02651,0,0,0-9.99065-.56794c-6.91508,1.43582-17.43368,4.06347-20.31728,7.207-4.39941,4.79935-10.79855,9.39873-17.99758,29.396l38.79478,13.99811-3.31958,6.31114-30.87582,58.6801s-1.02388,1.66777-2.41168,3.84748v.004c-1.79976,2.82762-4.20744,6.51511-5.78721,8.54684-2.79962,3.59952-1.99973,14.998-1.99973,14.998s-.59992,5.39927-2.59965,7.399-1.59979,9.39873-1.59979,9.39873L753.57134,609.84s-4.79936,4.3994-4.79936,6.39913-3.79949,7.599-3.79949,7.599S739.17328,633.4368,744.97249,632.037Z",
  transform: "translate(-41 -48.59028)",
  fill: "#434175"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M949.7449,646.435s-12.5983,4.19944-15.99784,10.19863S949.7449,646.435,949.7449,646.435Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M943.34576,633.23682c-.39994.59992-17.25509,17.51311-16.19781,21.59709S943.34576,633.23682,943.34576,633.23682Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M850.75824,645.23521S831.96077,654.1,830.361,657.9665,850.75824,645.23521,850.75824,645.23521Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M849.5584,656.63367s-16.96416,7.199-19.28063,8.99879S849.5584,656.63367,849.5584,656.63367Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M841.75945,672.0316s-7.5132,5.59924-11.65554,1.19983S841.75945,672.0316,841.75945,672.0316Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M869.95894,526.05127c-.40323.59991-25.39986,45.59385-31.999,48.99339S869.95894,526.05127,869.95894,526.05127Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M868.75581,543.049c0,.99987-24.39671,53.19284-28.39617,53.79276S868.75581,543.049,868.75581,543.049Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M775.96832,576.64445s-11.78285,25.16161-16.39779,26.59641S775.96832,576.64445,775.96832,576.64445Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M773.96859,565.446s-4.06191,8.79881-6.53035,8.79881S773.96859,565.446,773.96859,565.446Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M887.5575,394.87684a34.46269,34.46269,0,0,1-1.73,10.8,28.26947,28.26947,0,0,1-1,2.65,10.17243,10.17243,0,0,1-4.8501-2.13,12.00764,12.00764,0,0,1-3.62988-3.88,48.61159,48.61159,0,0,1-1.77-5.05,11.74816,11.74816,0,0,0-9.49-7.19c1.1499,1.96-.68006,4.65-2.93006,5-2.25.34-4.44006-1-5.99-2.67s-2.67-3.7-4.21008-5.37c-1.54993-1.67-3.74-3.01-5.99-2.67-1.99.3-3.53,1.82-5.19995,2.95-1.65991,1.13-3.99,1.89-5.6.68-.9-.67-1.34-1.81-2.20007-2.54-2.21-1.85-5.6499.06-7.28,2.45-2.51,3.7-4.03992,5.94-7.29993,7.61-.02-.21-.02-.43-.02-.64a34.595,34.595,0,1,1,69.19007,0Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M825.6906,386.90634c1.62718-2.39179,5.065-4.30409,7.28122-2.44484.86018.72163,1.29914,1.86275,2.19587,2.53842,1.6072,1.211,3.94041.45116,5.60278-.68291s3.20652-2.64717,5.196-2.94988c2.25047-.34244,4.44354.99889,5.989,2.67028s2.66569,3.69912,4.21158,5.37007,3.74,3.01111,5.9902,2.66675,4.08463-3.03692,2.928-4.99753a11.75059,11.75059,0,0,1,9.48761,7.18953,48.68984,48.68984,0,0,0,1.77158,5.04921,11.97717,11.97717,0,0,0,3.63442,3.87646c1.83506,1.34511,4.05888,2.47941,6.30044,2.08931s4.1389-2.95858,3.09718-4.98136c.7163,1.08793,2.25414-.4275,2.48674-1.70913a18.28969,18.28969,0,0,0-.46235-8.44019c-1.10509-3.71706-3.42328-7.40323-2.52995-11.17679.70727-2.98761,3.2604-5.13283,4.81025-7.78312,2.74749-4.69829,2.01834-11.02728-1.32279-15.32373a17.42237,17.42237,0,0,0-14.394-6.30906,23.79953,23.79953,0,0,1-4.52582.08432c-2.51062-.37282-4.6338-1.9889-6.63456-3.55069l-16.75017-13.07518a20.61143,20.61143,0,0,0-6.33131-3.81453c-2.36706-.73412-5.20465-.48084-6.957,1.27168-3.136,3.13639-1.14257,8.53378-2.40165,12.78656-1.09052,3.68345-4.601,6.17966-8.23538,7.42386s-7.52324,1.51731-11.25766,2.418a6.17672,6.17672,0,0,0-3.01257,1.40276,5.95866,5.95866,0,0,0-1.30891,4.25152A23.173,23.173,0,0,0,813.14952,371.57c1.93977,3.73042,5.01411,7.56469,3.926,11.62606-.57589,2.14948-2.23192,3.80549-3.692,5.48482-3.16537,3.64058-4.23373,9.02,1.72246,7.14084C820.84333,394.01156,822.45273,391.66568,825.6906,386.90634Z",
  transform: "translate(-41 -48.59028)",
  fill: "#434175"
});

var _ref105 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M891.86675,396.64816c-.23266,1.28168-1.77051,2.79706-2.48681,1.70917,1.04174,2.02276-.8556,4.59124-3.09717,4.98132s-4.46533-.7442-6.30042-2.0893a11.976,11.976,0,0,1-3.6344-3.87646,48.691,48.691,0,0,1-1.7716-5.04919,11.75062,11.75062,0,0,0-9.48767-7.18952c1.15673,1.96057-.67774,4.65314-2.928,4.9975s-4.44422-.99579-5.99011-2.66675-2.66614-3.69867-4.21155-5.37006-3.73853-3.01269-5.989-2.67028c-1.9895.30273-3.53357,1.81579-5.196,2.94989s-3.99548,1.89392-5.60278.68292c-.89673-.67566-1.3357-1.81683-2.19581-2.53845-2.21618-1.85926-5.654.0531-7.28125,2.44482-3.23779,4.7594-4.84716,7.10523-10.58471,8.91541-1.88343.59423-3.06092.45983-3.69531-.1131-1.259,2.89142-.68567,5.43786,3.69531,4.05566,5.73755-1.81018,7.34692-4.15607,10.58471-8.9154,1.6272-2.39179,5.06507-4.30408,7.28125-2.44483.86011.72162,1.29908,1.86273,2.19581,2.53839,1.6073,1.211,3.94043.45118,5.60278-.68286s3.20654-2.64721,5.196-2.94989c2.25049-.34247,4.44361.9989,5.989,2.67029s2.66565,3.6991,4.21155,5.37006,3.74,3.0111,5.99011,2.66674,4.08471-3.03692,2.928-4.99755a11.75067,11.75067,0,0,1,9.48767,7.18957,48.701,48.701,0,0,0,1.7716,5.0492,11.97657,11.97657,0,0,0,3.6344,3.87646c1.83509,1.34509,4.059,2.47937,6.30042,2.08929s4.13891-2.95855,3.09717-4.98138c.7163,1.088,2.25415-.42749,2.48681-1.70911a18.26312,18.26312,0,0,0,.18042-5.23108C892.00079,395.791,891.94414,396.22122,891.86675,396.64816Z",
  transform: "translate(-41 -48.59028)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M817.02788,379.40536c.01526-.05145.03736-.09979.05127-.15186,1.08814-4.06134-1.98632-7.89563-3.926-11.626a23.17661,23.17661,0,0,1-2.4856-8.44593,11.226,11.226,0,0,0-.11462,1.57459A23.17266,23.17266,0,0,0,813.15313,371.57C814.47906,374.12008,816.33367,376.71884,817.02788,379.40536Z",
  transform: "translate(-41 -48.59028)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M893.68462,369.24807c-1.5498,2.65033-4.103,4.79553-4.8103,7.78314a8.682,8.682,0,0,0,.0354,3.83179c.74439-2.9284,3.24487-5.056,4.7749-7.67236a13.14208,13.14208,0,0,0,1.53992-8.44263A12.3725,12.3725,0,0,1,893.68462,369.24807Z",
  transform: "translate(-41 -48.59028)"
}));

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M770.757,550.096v.004a30.53357,30.53357,0,0,1,.61193,3.34754s15.79787,36.995,17.7976,39.19472c.61593.67591,2.93564,4.00347,5.85121,8.28687,1.05587,1.54779,2.1877,3.22357,3.34755,4.94333,6.04718,8.97479,12.79828,19.16544,12.79828,19.16544l14.798,12.99825s32.19166,2.57565,42.42231-7.87094c-1.23987-.8639-2.02775-1.32782-2.02775-1.32782l-4.39941-3.41954c-2.27167-3.83149-10.95853-7.563-19.75334-10.49461-8.10292.06-14.73.71592-14.73.71592l-2.10772-5.55125-2.19971-5.79121-11.18648-29.452s-7.215-37.195-9.61472-38.99475-1.79976-7.399-1.79976-7.399,4.39941-15.79787,2.79963-17.99757,2.59965-18.39752,2.59965-18.39752a16.77811,16.77811,0,0,0-1.91977-4.48741l-30.87582,58.6801S772.14481,547.91631,770.757,550.096Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M806.36422,490.856s-4.19943,16.19781-2.59965,18.39752S800.965,527.2511,800.965,527.2511s-.59992,5.59925,1.79976,7.399,9.61423,38.99474,9.61423,38.99474l15.49349,40.79451s48.48236-4.79936,43.483,10.39859-44.99393,11.99839-44.99393,11.99839l-14.798-12.99825s-19.9973-30.19593-21.997-32.39564-17.79761-39.19471-17.79761-39.19471-.79989-7.399-4.19943-11.1985-.79989-10.22591-.79989-10.22591-4.19944-48.36619.2-54.16541S801.76484,473.45835,806.36422,490.856Z",
  transform: "translate(-41 -48.59028)",
  fill: "#ee8e9e"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M781.56756,460.4601l-12.5983,7.599s-3.59951,12.19836-6.39914,13.79814c0,0,25.19661-13.99811,44.19405,18.19755,0,0-.59992-4.19944,1.99973-6.19917s1.99973-10.59857,1.99973-10.59857a34.62783,34.62783,0,0,0,1.79976-4.19943C814.36314,474.65819,804.96441,449.46159,781.56756,460.4601Z",
  transform: "translate(-41 -48.59028)",
  opacity: 0.1
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M781.16762,459.66021l-12.59831,7.599s-3.59951,12.19835-6.39913,13.79814c0,0,25.1966-13.99812,44.194,18.19755,0,0-.59992-4.19944,1.99973-6.19917s1.99973-10.59857,1.99973-10.59857a34.628,34.628,0,0,0,1.79976-4.19944C813.9632,473.8583,804.56446,448.66169,781.16762,459.66021Z",
  transform: "translate(-41 -48.59028)",
  fill: "#434175"
});

var _ref110 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 627.87865,
  cy: 721.4106,
  rx: 37.55691,
  ry: 39.86537,
  fill: "#fbd56f"
});

var _ref111 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 627.87865,
  cy: 721.4106,
  rx: 37.55691,
  ry: 39.86537,
  opacity: 0.1
});

var _ref112 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 634.36028,
  cy: 722.29847,
  rx: 37.55691,
  ry: 38.9775,
  fill: "#fbd56f"
});

var _ref113 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 90.14278,
  cy: 735.4768,
  rx: 46.38569,
  ry: 7.84147,
  fill: "#6c63ff"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M150.323,771.23847c1.9865-1.84587,3.85-4.02343,4.42238-6.67409s-.55733-5.82918-3.09023-6.79772c-2.83814-1.08534-5.87095.882-8.17033,2.86845s-4.93467,4.254-7.944,3.83335a12.09383,12.09383,0,0,0,3.74017-11.319,4.72823,4.72823,0,0,0-1.04018-2.29856c-1.57548-1.68433-4.43155-.961-6.318.36591-5.99917,4.21978-7.67313,12.36876-7.70577,19.70332-.605-2.64562-.09543-5.40251-.11036-8.11641s-.75865-5.72232-3.048-7.17991a9.182,9.182,0,0,0-4.64878-1.09267c-2.69672-.09919-5.7002.17116-7.54186,2.14353-2.28826,2.45069-1.69479,6.56252.29593,9.26048s5.01878,4.38843,7.806,6.252a17.30858,17.30858,0,0,1,5.57844,5.32076,5.26669,5.26669,0,0,1,.41355.95058H139.868A47.11021,47.11021,0,0,0,150.323,771.23847Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M550.62131,732.93427a40.43626,40.43626,0,0,1,5.02749,9.18054c.33594.84417.66474,1.73114.97583,2.66168,4.99732,14.93518-2.92108,32.845-5.18487,30.91315s-9.31824-5.5163-10.68228-.47931-6.40284,10.1853-6.40284,10.1853c-9.18017,9.23346-17.48977-.7428-22.94418-11.05048a99.84636,99.84636,0,0,1-4.74548-10.48523c-1.211-3.16558-1.90656-5.35339-1.90656-5.35339l38.23682-32.57873S546.69174,727.62488,550.62131,732.93427Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M490.3573,753.7663a40.43668,40.43668,0,0,1,5.0275,9.18054c.33593.84418.66473,1.73114.97583,2.66168,4.99731,14.93518-2.92109,32.845-5.18485,30.91315s-9.31824-5.5163-10.68228-.47931-6.40283,10.1853-6.40283,10.1853c-9.18018,9.23346-17.48978-.7428-22.94419-11.05047A99.84934,99.84934,0,0,1,446.401,784.692c-1.211-3.16559-1.90655-5.3534-1.90655-5.3534l38.23681-32.57873S486.42773,748.45685,490.3573,753.7663Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M369.35394,782.5459a40.43562,40.43562,0,0,1-1.98837,10.27637c-.28012.86431-.59305,1.757-.94739,2.672-5.68417,14.6875-23.21017,23.42243-23.72018,20.49042s-3.65347-10.19366-7.91815-7.18634-11.42957,3.75519-11.42957,3.75519c-12.96033,1.25-12.991-11.73371-10.61188-23.15033a99.84576,99.84576,0,0,1,3.03812-11.10083c1.08792-3.2099,1.94867-5.3382,1.94867-5.3382l50.22916-.67926S369.71707,775.9505,369.35394,782.5459Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M304.45518,766.17792a40.4359,40.4359,0,0,1-1.98837,10.27636c-.2801.86432-.593,1.757-.9474,2.672-5.68416,14.6875-23.21022,23.42243-23.72022,20.49042s-3.65347-10.19367-7.91816-7.18634-11.42957,3.75519-11.42957,3.75519c-12.96033,1.25-12.991-11.73371-10.61189-23.15033a99.84793,99.84793,0,0,1,3.03812-11.10083c1.08793-3.2099,1.94866-5.3382,1.94866-5.3382l50.22915-.67926S304.81831,759.58246,304.45518,766.17792Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M652.616,546.04413c0,134.15881-45.384,242.91608-254.82007,242.91608-140.73325,0-249.61209-34.968-254.82008-242.91608-3.359-134.11682,114.08677-242.91611,254.82-242.91611S652.616,411.88525,652.616,546.04413Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M494.96191,342.75363s65.10956-55.32931,93.91315-45.20471c0,0,23.3584,25.50644-24.71442,73.37195Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M698,607.79614c0,72.113-51.74841,129.084-100.44,129.084s-75.888-56.97107-75.888-129.084,39.554-127.75406,88.164-130.57205C686.84,472.76007,698,535.68317,698,607.79614Z",
  transform: "translate(-41 -48.59028)",
  fill: "#6c63ff"
});

var _ref122 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 553.58395,
  cy: 569.99383,
  rx: 16.36801,
  ry: 20.83203,
  fill: "#6c63ff"
});

var _ref123 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 611.61597,
  cy: 552.13787,
  rx: 16.36798,
  ry: 20.83203,
  fill: "#6c63ff"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M505.61646,350.59521a29.70279,29.70279,0,0,1-3.17692,13.43665,28.55141,28.55141,0,0,1-12.8117,12.78192,298.49667,298.49667,0,0,0-38.69541-34.66293,29.161,29.161,0,0,1,6.39838-11.44272,27.42912,27.42912,0,0,1,20.34094-9.114C493.10236,321.59412,505.61646,334.57687,505.61646,350.59521Z",
  transform: "translate(-41 -48.59028)",
  fill: "#fad46f"
});

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "coins-svg",
    id: "a329d3bf-4b11-4261-9182-40685c3b1c8f",
    "data-name": "Layer 1",
    width: 300,
    height: 250.81944,
    viewBox: "0 0 1118 802.81944",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, /*#__PURE__*/React.createElement("path", {
    d: "M550.62131,732.93427a40.43626,40.43626,0,0,1,5.02749,9.18054c.33594.84417.66474,1.73114.97583,2.66168,4.99732,14.93518-2.92108,32.845-5.18487,30.91315s-9.31824-5.5163-10.68228-.47931-6.40284,10.1853-6.40284,10.1853c-9.18017,9.23346-17.48977-.7428-22.94418-11.05048a99.84636,99.84636,0,0,1-4.74548-10.48523c-1.211-3.16558-1.90656-5.35339-1.90656-5.35339l38.23682-32.57873S546.69174,727.62488,550.62131,732.93427Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.3573,753.7663a40.43668,40.43668,0,0,1,5.0275,9.18054c.33593.84418.66473,1.73114.97583,2.66168,4.99731,14.93518-2.92109,32.845-5.18485,30.91315s-9.31824-5.5163-10.68228-.47931-6.40283,10.1853-6.40283,10.1853c-9.18018,9.23346-17.48978-.7428-22.94419-11.05047A99.84934,99.84934,0,0,1,446.401,784.692c-1.211-3.16559-1.90655-5.3534-1.90655-5.3534l38.23681-32.57873S486.42773,748.45685,490.3573,753.7663Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35394,782.5459a40.43562,40.43562,0,0,1-1.98837,10.27637c-.28012.86431-.59305,1.757-.94739,2.672-5.68417,14.6875-23.21017,23.42243-23.72018,20.49042s-3.65347-10.19366-7.91815-7.18634-11.42957,3.75519-11.42957,3.75519c-12.96033,1.25-12.991-11.73371-10.61188-23.15033a99.84576,99.84576,0,0,1,3.03812-11.10083c1.08792-3.2099,1.94867-5.3382,1.94867-5.3382l50.22916-.67926S369.71707,775.9505,369.35394,782.5459Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.45518,766.17792a40.4359,40.4359,0,0,1-1.98837,10.27636c-.2801.86432-.593,1.757-.9474,2.672-5.68416,14.6875-23.21022,23.42243-23.72022,20.49042s-3.65347-10.19367-7.91816-7.18634-11.42957,3.75519-11.42957,3.75519c-12.96033,1.25-12.991-11.73371-10.61189-23.15033a99.84793,99.84793,0,0,1,3.03812-11.10083c1.08793-3.2099,1.94866-5.3382,1.94866-5.3382l50.22915-.67926S304.81831,759.58246,304.45518,766.17792Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref119, /*#__PURE__*/React.createElement("path", {
    d: "M349.99387,307.3688h.02978a.05793.05793,0,0,1-.02234.00742Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4924,307.287c.64728-.10413,1.92694-.28272,3.78693-.42411l-4.14411.49106q.08926-.02233.22318-.04464C350.40308,307.30185,350.44031,307.2944,350.4924,307.287Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.78394,406.544l-18.6,6.696a415.47072,415.47072,0,0,0-30.55609-36.42627,298.49667,298.49667,0,0,0-38.69541-34.66293c-47.62347-35.29538-84.45892-36.19562-96.62335-35.288l27.95954-3.28845a227.31886,227.31886,0,0,1,75.06219,27.1337,247.97733,247.97733,0,0,1,45.10873,33.32376C526.78323,386.62717,538.78394,406.544,538.78394,406.544Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63989,419.19205s-24.552-81.84-3.72-104.16c0,0,32.736-11.16,57.288,52.08Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref120, /*#__PURE__*/React.createElement("path", {
    d: "M494.96191,342.75363s65.10956-55.32931,93.91315-45.20471c0,0,23.3584,25.50644-24.71442,73.37195Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref121, /*#__PURE__*/React.createElement("path", {
    d: "M698,607.79614c0,72.113-51.74841,129.084-100.44,129.084s-75.888-56.97107-75.888-129.084,39.554-127.75406,88.164-130.57205C686.84,472.76007,698,535.68317,698,607.79614Z",
    transform: "translate(-41 -48.59028)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref122, _ref123, _ref124);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.6977adf2.svg";
export { ForwardRef as ReactComponent };